<template>
  <v-footer
    id="core-footer"
    absolute
    height="82"
  >
    <!--<div class="footer-items">-->
    <!--<span-->
    <!--v-for="link in links"-->
    <!--:key="link.name"-->
    <!--&gt;-->
    <!--<a-->
    <!--:href="link.Link"-->
    <!--class="tertiary&#45;&#45;text footer-links">{{ link.name }}</a>-->
    <!--</span>-->
    <!--</div>-->
    <v-spacer/>
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      Krita
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      { name: 'Home', Link: '/dashboard' },
      { name: 'About Us', Link: 'https://krita.is/' },
    ]
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
